import { Box, CircularProgress, Typography } from '@mui/material';
import { useIntl } from 'react-intl';

import { downloadPreviewCsv, usePreviewMapping } from '@verantos-dev/feature-epi-chat';

import { ConceptGroupMappingPanel } from '../components/ConceptGroupMappingPanel';

// --- Mapping results tab — the source→mapped audit for a map-first upload.
// Rendered with the concept-group ConceptGroupMappingPanel (built on the same
// base as the Concepts tab), NOT the legacy MappingResultsGrid. OR-6288. -----

export const DraftMappingTab = ({
  previewId,
  enabled,
  conceptGroupName,
}: {
  previewId: string | null;
  enabled: boolean;
  conceptGroupName: string;
}) => {
  const { formatMessage } = useIntl();
  const { data, isLoading, isError } = usePreviewMapping(previewId, enabled);

  if (isLoading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', paddingY: 4 }}>
        <CircularProgress data-testid="cg-preview-mapping-loading" />
      </Box>
    );
  }
  if (isError) {
    return (
      <Typography variant="body2" color="error" data-testid="cg-preview-mapping-error">
        {formatMessage({ id: 'epiChat.conceptGroupPreview.mapping.loadError' })}
      </Typography>
    );
  }
  if (!data || data.length === 0) {
    return (
      <Typography variant="body2" color="text.secondary" data-testid="cg-preview-mapping-empty">
        {formatMessage({ id: 'epiChat.conceptGroupPreview.mapping.empty' })}
      </Typography>
    );
  }

  return (
    <ConceptGroupMappingPanel
      results={data}
      testIdPrefix="cg-preview"
      onDownload={previewId ? () => downloadPreviewCsv(previewId, conceptGroupName) : undefined}
    />
  );
};
